// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
import { defineMessages } from 'react-intl';

// Import/Export to trigger Traduki translations for common component

export const messages: {
	/**
	 * Product-agnostic messages
	 */
	common_updated_date_formatter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_recently_viewed_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_recently_spaces_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_recently_worked_with_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_error_state_failed_search_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_error_state_failed_search_body: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_empty_state_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_empty_state_prequery_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_error_state_prequery_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_show_more_results_link: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_show_all_results_link: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_search_people_link: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_search_input_collapsed_placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_search_input_aria_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_search_input_enlarged_aria_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_empty_state_body: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_empty_state_body_no_advanced_search: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_give_feedback: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_inline_onboarding_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_inline_onboarding_body: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_inline_onboarding_action: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_search_input_exit_button_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_search_input_clear_button_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multi_site_advanced_search_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multi_site_advanced_search_more_dropdown: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	common_autocorrection_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	/**
	 * Cross product
	 */
	jira_tab_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluence_tab_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	atlas_tab_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bitbucket_tab_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	opsgenie_tab_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	trello_tab_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	view_all_results_link: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recently_viewed_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	/**
	 * Common Confluence Messages
	 */
	confluence_people_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluence_content_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluence_spaces_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluence_search_input_expanded_placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluence_search_input_expanded_placeholder_ai: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluence_pages_blogs_attachments_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	/**
	 * Common Filtering Messages
	 */
	filters_applied: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clear_filters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	show_more_filters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	more_filters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	no_options_filters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading_filters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	site_filters_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	space_filters_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributor_filters_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributor_filters_find_more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	space_filters_find_more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	site_filters_find_more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	project_filters_find_more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	project_filters_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assignee_filters_find_more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assignee_filters_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	binary_status_category_filters_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	binary_status_category_filter_option_done: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	binary_status_category_filter_option_open: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	date_filter_any_time_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	date_filter_filters_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	/**
	 * Common Jira Messages
	 */
	jira_advanced_search_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_advanced_search_projects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_advanced_search_boards: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_advanced_search_filters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_advanced_search_plans: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_advanced_search_people: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_empty_state_prequery_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_boards_projects_filters_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_projects_filters_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_boards_projects_filters_plans_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_recent_boards_projects_filters_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_recent_projects_filters_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_recent_boards_projects_filters_plans_section_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_search_placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_search_placeholder_experiment_jsw_enabled: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_advanced_search_issuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_issues_section_headingIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_view_all_issues_newIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_recently_viewed_issues_section_headingIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_search_placeholder_experiment_jsw_enabledIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	/**
	 * Product-agnostic messages
	 */
	common_updated_date_formatter: {
		id: 'product_search_dialog.updated_date_formatter',
		defaultMessage: 'Updated {date}',
		description: 'A text shown next to the date for the search results.',
	},
	common_recently_viewed_section_heading: {
		id: 'product_search_dialog.recently_viewed_section_heading',
		defaultMessage: 'Recently viewed',
		description: 'Section heading listing items the user has recently viewed in search.',
	},
	common_recently_spaces_section_heading: {
		id: 'product_search_dialog.recent_spaces_section_heading',
		defaultMessage: 'Recent spaces',
		description: 'Section heading listing Confluence spaces the user has recently visited.',
	},
	common_recently_worked_with_section_heading: {
		id: 'product_search_dialog.recently_worked_with_section_heading',
		defaultMessage: 'Recently worked with',
		description: 'Section heading showing people the user has recently collaborated with.',
	},
	common_error_state_failed_search_heading: {
		id: 'product_search_dialog.error.failed_loading_search_heading',
		defaultMessage: "We're having trouble loading your recently viewed content.",
		description: 'Heading shown in the search dialog when recently viewed content fails to load.',
	},
	common_error_state_failed_search_body: {
		id: 'product_search_dialog.error.failed_loading_search_body',
		defaultMessage:
			'It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>',
		description: 'Body text in the search error state; emptyLink is a clickable retry link.',
	},
	common_empty_state_heading: {
		id: 'product_search_dialog.empty.no_results_heading',
		defaultMessage: "We couldn't find anything matching your search.",
		description: 'Heading displayed when a search query returns no matching results.',
	},
	common_empty_state_prequery_heading: {
		id: 'product_search_dialog.empty_prequery.no_results_heading',
		defaultMessage: 'Search for what you need',
		description: 'Heading shown in the search dialog before the user has typed a query.',
	},
	common_error_state_prequery_heading: {
		id: 'product_search_dialog.empty_prequery.error_heading',
		defaultMessage: 'Something went wrong with showing initial results',
		description: 'Heading shown in the search dialog when initial pre-query results fail to load.',
	},
	common_show_more_results_link: {
		id: 'product_search_dialog.show_more_results_link',
		defaultMessage: 'Show more',
		description: 'Link label to expand and display additional search results in the dialog.',
	},
	common_show_all_results_link: {
		id: 'product_search_dialog.show_all_results_link',
		defaultMessage: 'View all results',
		description: 'Link label to navigate to the full search results page from the dialog.',
	},
	common_search_people_link: {
		id: 'product_search_dialog.search_people_link',
		defaultMessage: 'Search people',
		description: 'Link label to navigate to the people search results from the search dialog.',
	},
	common_search_input_collapsed_placeholder: {
		id: 'product_search_dialog.search_input_collapsed_placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder text for the collapsed search input in the search dialog.',
	},
	common_search_input_aria_label: {
		id: 'product_search_dialog.search_input_aria_label',
		defaultMessage: 'Search, press enter to navigate to advanced search with your text query',
		description: 'Aria label for primary search input, directs users advanced search',
	},
	common_search_input_enlarged_aria_label: {
		id: 'product_search_dialog.search_input_enlarged_aria_label',
		defaultMessage: 'Press enter to navigate to advanced search',
		description: 'used for accessibility for the EnlargedSearchInput component',
	},
	common_empty_state_body: {
		id: 'product_search_dialog.empty.no_results_body',
		defaultMessage:
			'Try again with a different term, or refine your results with <a>Advanced Search</a>',
		description:
			'Body text for no-results state; the anchor tag links to the Advanced Search page.',
	},
	common_empty_state_body_no_advanced_search: {
		id: 'product_search_dialog.empty.no_results_body_with_no_advanced_search',
		defaultMessage: 'Try again with a different term.',
		description: 'Body text for no-results state when Advanced Search is not available.',
	},
	common_give_feedback: {
		id: 'product_search_dialog.give_feedback',
		defaultMessage: 'Give feedback',
		description:
			'Button that looks like a link that the user clicks to open a dialog to give feedback about search',
	},
	common_inline_onboarding_title: {
		id: 'product_search_dialog.inline_onboarding_title',
		defaultMessage: 'Search across Jira and Confluence',
		description:
			'Heading of the inline section message which educates first time users about cross product search tabs',
	},
	common_inline_onboarding_body: {
		id: 'product_search_dialog.inline_onboarding_body',
		defaultMessage:
			'Use the Jira and Confluence tabs to search and see recent items in either location.',
		description:
			'Description of the inline section message which educates first time users about cross product search tabs',
	},
	common_inline_onboarding_action: {
		id: 'product_search_dialog.inline_onboarding_action',
		defaultMessage: 'Ok',
		description: 'A button that looks like a link which suspends the section message.',
	},
	common_search_input_exit_button_label: {
		id: 'search_dialog.search_input_exit_label',
		defaultMessage: 'Exit Search',
		description: 'Label for the back button to exit search',
	},
	common_search_input_clear_button_label: {
		id: 'search_dialog.search_input_clear_label',
		defaultMessage: 'Clear search session',
		description: 'Label for the x button to clear the search input',
	},
	multi_site_advanced_search_label: {
		id: 'product_search_dialog.multi_site_advanced_search_label',
		defaultMessage: 'Search on:',
		description: 'Label for a list of site links in advanced search',
	},
	multi_site_advanced_search_more_dropdown: {
		id: 'product_search_dialog.multi_site_advanced_search_more_dropdown',
		defaultMessage: '{count} more',
		description: 'A dropdown which opens a list of links to sites to advanced search in',
	},
	common_autocorrection_label: {
		id: 'product_search_dialog.autocorrection.label',
		defaultMessage: 'Did you mean',
		description: 'Label text for the autocorrection component',
	},
	/**
	 * Cross product
	 */
	jira_tab_label: {
		id: 'cross_product_search_dialog.jira.tab_label',
		defaultMessage: 'Jira',
		description: 'Tab label in the cross-product search dialog for switching to Jira results.',
	},
	confluence_tab_label: {
		id: 'cross_product_search_dialog.confluence.tab_label',
		defaultMessage: 'Confluence',
		description:
			'Tab label in the cross-product search dialog for switching to Confluence results.',
	},
	atlas_tab_label: {
		id: 'cross_product_search_dialog.atlas.tab_label',
		defaultMessage: 'Atlas',
		description:
			'Tab label in the cross-product search dialog for the Atlas product, used to switch to Atlas search results.',
	},
	bitbucket_tab_label: {
		id: 'cross_product_search_dialog.bitbucket.tab_label',
		defaultMessage: 'Bitbucket',
		description: 'Tab label in the cross-product search dialog for switching to Bitbucket results.',
	},
	opsgenie_tab_label: {
		id: 'cross_product_search_dialog.opsgenie.tab_label',
		defaultMessage: 'Opsgenie',
		description: 'Tab label in the cross-product search dialog for switching to Opsgenie results.',
	},
	trello_tab_label: {
		id: 'cross_product_search_dialog.trello.tab_label',
		defaultMessage: 'Trello',
		description: 'Tab label in the cross-product search dialog for switching to Trello results.',
	},
	view_all_results_link: {
		id: 'cross_product_search_dialog.view_all_results_link',
		defaultMessage: 'View all {sectionTitle}',
		description: 'Link to view all results; {sectionTitle} is the product or section name.',
	},
	recently_viewed_title: {
		id: 'cross_product_search_dialog.recently_viewed_title',
		defaultMessage: 'Recently Viewed {sectionTitle}',
		description: 'Section heading for recently viewed items; {sectionTitle} is the product name.',
	},
	/**
	 * Common Confluence Messages
	 */
	confluence_people_section_heading: {
		id: 'product_search_dialog.confluence.people_section_heading',
		defaultMessage: 'People',
		description: 'Section heading for people results in the Confluence search dialog.',
	},
	confluence_content_section_heading: {
		id: 'product_search_dialog.confluence.content_section_heading',
		defaultMessage: 'Content',
		description:
			'Section label for pages, blogs, attachments, and whiteboards in quick search dialog',
	},
	confluence_spaces_section_heading: {
		id: 'product_search_dialog.confluence.spaces_section_heading',
		defaultMessage: 'Spaces',
		description: 'Section heading for Confluence spaces results in the search dialog.',
	},
	confluence_search_input_expanded_placeholder: {
		id: 'product_search_dialog.confluence.search_input_expanded_placeholder',
		defaultMessage: 'Search Confluence',
		description: 'Placeholder text for the expanded search input when searching in Confluence.',
	},
	confluence_search_input_expanded_placeholder_ai: {
		id: 'product_search_dialog.confluence.search_input_expanded_placeholder_ai',
		defaultMessage: 'Search or ask questions within your Confluence',
		description: 'Placeholder for the expanded search input when AI-assisted search is enabled.',
	},
	confluence_pages_blogs_attachments_section_heading: {
		id: 'product_search_dialog.confluence.pages_blogs_attachments_section_heading',
		defaultMessage: 'Pages, blogs and attachments',
		description:
			'Section heading grouping Confluence pages, blogs, and attachments in search results.',
	},
	/**
	 * Common Filtering Messages
	 */
	filters_applied: {
		id: 'product_search_dialog.confluence.filters_applied',
		defaultMessage: 'Looks like you have some filters applied',
		description: 'Message to show when there are no search results due to filters being applied',
	},
	clear_filters: {
		id: 'product_search_dialog.confluence.clear_filters',
		defaultMessage: 'Clear filters',
		description: 'Message to be displayed on button to clear the filters applied',
	},
	show_more_filters: {
		id: 'search_dialog.filters.group.show-more',
		defaultMessage: 'Show more',
		description: 'Text display on button to select more items to filter by',
	},
	more_filters: {
		id: 'product_search_dialog.more_filters',
		defaultMessage: 'View all filters',
		description: 'Clicking on this link takes a user to a page with more filters and options.',
	},
	no_options_filters: {
		id: 'product_search_dialog.no_options_filters',
		defaultMessage: 'No options',
		description: 'Message to show when no results are returned when filtering',
	},
	loading_filters: {
		id: 'product_search_dialog.loading_filters',
		defaultMessage: 'Loading',
		description: 'Message to show when filter results are loading',
	},
	site_filters_title: {
		id: 'product_search_dialog.common.site_filters',
		defaultMessage: 'Filter by site',
		description:
			'Section heading in the search dialog filter panel that groups site-scoping filter options, allowing users to limit results to a specific site.',
	},
	space_filters_title: {
		id: 'product_search_dialog.confluence.space_filters',
		defaultMessage: 'Filter by space',
		description: 'Section title for space filters in Confluence',
	},
	contributor_filters_title: {
		id: 'product_search_dialog.confluence.contributor_filters',
		defaultMessage: 'Filter by contributor',
		description: 'Section title for contributor filters in Confluence',
	},
	contributor_filters_find_more: {
		id: 'product_search_dialog.confluence.contributor_filters_find_more',
		defaultMessage: 'Find a contributor',
		description: 'Placeholder text for select menu when finding a contributor to filter results by',
	},
	space_filters_find_more: {
		id: 'product_search_dialog.confluence.space_filters_find_more',
		defaultMessage: 'Find a space',
		description: 'Placeholder text for select menu when finding a space to filter results by',
	},
	site_filters_find_more: {
		id: 'product_search_dialog.jira.site_filters_find_more',
		defaultMessage: 'Find a site',
		description: 'Placeholder text for select menu when finding a site to filter results by',
	},
	project_filters_find_more: {
		id: 'product_search_dialog.jira.project_filters_find_more',
		defaultMessage: 'Find a project',
		description: 'Placeholder text for select menu when finding a project to filter results by',
	},
	project_filters_title: {
		id: 'product_search_dialog.jira.project_filters',
		defaultMessage: 'Filter by project',
		description: 'Section title for project filters in Jira',
	},
	assignee_filters_find_more: {
		id: 'product_s earch_dialog.confluence.assignee_filters_find_more',
		defaultMessage: 'Find an assignee',
		description: 'Placeholder text for select menu when finding a assignee to filter results by',
	},
	assignee_filters_title: {
		id: 'product_search_dialog.jira.assignee_filters',
		defaultMessage: 'Filter by assignee',
		description: 'Section title for assignee filters in Jira',
	},
	binary_status_category_filters_title: {
		id: 'product_search_dialog.jira.issue_filters',
		defaultMessage: 'Filter by status',
		description:
			'Section heading for the status filter group in the Jira search dialog, allowing users to narrow results by issue status.',
	},
	binary_status_category_filter_option_done: {
		id: 'product_search_dialog.jira.issue_filter_done',
		defaultMessage: 'Done',
		description:
			'Checkbox label in the Jira status filter that, when selected, includes issues with a Done status in search results.',
	},
	binary_status_category_filter_option_open: {
		id: 'product_search_dialog.jira.issue_filter_open',
		defaultMessage: 'Open',
		description:
			'Checkbox label in the Jira status filter that, when selected, includes issues with an Open status in search results.',
	},
	date_filter_any_time_label: {
		id: 'product_search_dialog.jira.date_filter_any',
		defaultMessage: 'Any time',
		description:
			'Drop-down option in the Jira search date filter that removes date restrictions, returning results from any time period.',
	},
	date_filter_filters_title: {
		id: 'product_search_dialog.jira.date_filters',
		defaultMessage: 'Last updated',
		description:
			'Section heading for the last-updated date filter group in the Jira search dialog, allowing users to narrow results by when issues were last modified.',
	},
	/**
	 * Common Jira Messages
	 */
	jira_advanced_search_label: {
		id: 'global_search.jira.advanced_search_label',
		defaultMessage: 'Go to all:',
		description: 'Prefix label before the list of Jira advanced search navigation links.',
	},
	jira_advanced_search_projects: {
		id: 'global_search.jira.advanced_search_projects',
		defaultMessage: 'Projects',
		description:
			'Link label in the Jira advanced search footer that navigates to a full Jira projects search page.',
	},
	jira_advanced_search_boards: {
		id: 'global_search.jira.advanced_search_boards',
		defaultMessage: 'Boards',
		description:
			'Link label in the Jira advanced search footer that navigates to a full Jira boards search page.',
	},
	jira_advanced_search_filters: {
		id: 'global_search.jira.advanced_search_filters',
		defaultMessage: 'Filters',
		description:
			'Link label in the Jira advanced search footer that navigates to a full Jira filters search page.',
	},
	jira_advanced_search_plans: {
		id: 'global_search.jira.advanced_search_plans',
		defaultMessage: 'Plans',
		description:
			'Link label in the Jira advanced search footer that navigates to a full Jira plans search page.',
	},
	jira_advanced_search_people: {
		id: 'global_search.jira.advanced_search_people',
		defaultMessage: 'People',
		description:
			'Link label in the Jira advanced search footer to navigate to the people search page.',
	},
	jira_empty_state_prequery_heading: {
		id: 'product_search_dialog.jira.empty_prequery.no_results_heading',
		defaultMessage: 'Start searching to find your work',
		description:
			'This message is shown when the user has no recently viewed issues and has not yet typed a search query',
	},
	jira_boards_projects_filters_section_heading: {
		id: 'product_search_dialog.jira.boards_projects_filters_section_heading',
		defaultMessage: 'Boards, Projects and Filters',
		description: 'Section heading grouping Jira boards, projects, and filters in search results.',
	},
	jira_projects_filters_section_heading: {
		id: 'product_search_dialog.jira.projects_filters_section_heading',
		defaultMessage: 'Projects and Filters',
		description: 'Section heading grouping Jira projects and filters in the search results dialog.',
	},
	jira_boards_projects_filters_plans_section_heading: {
		id: 'product_search_dialog.jira.boards_projects_filters_plans_section_heading',
		defaultMessage: 'Boards, Projects, Filters and Plans',
		description: 'Title for search results of Jira entities (Boards, Projects, Filters, and Plans)',
	},
	jira_recent_boards_projects_filters_section_heading: {
		id: 'product_search_dialog.jira.recent_boards_projects_filters_section_heading',
		defaultMessage: 'Recent Boards, Projects and Filters',
		description: 'Section heading for recently accessed Jira boards, projects, and filters.',
	},
	jira_recent_projects_filters_section_heading: {
		id: 'product_search_dialog.jira.recent_projects_filters_section_heading',
		defaultMessage: 'Recent Projects and Filters',
		description: 'Section heading for recently accessed Jira projects and filters in the dialog.',
	},
	jira_recent_boards_projects_filters_plans_section_heading: {
		id: 'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading',
		defaultMessage: 'Recent Boards, Projects, Filters and Plans',
		description: 'Title for recently accessed Jira entities (Boards, Projects, Filters, and Plans)',
	},
	jira_search_placeholder: {
		id: 'global_search.jira.search_placeholder',
		defaultMessage: 'Search Jira',
		description: 'Search field placeholder when the Jira tab is active',
	},
	jira_search_placeholder_experiment_jsw_enabled: {
		id: 'global_search.jira.search_placeholder_experiment_jsw_enabled',
		defaultMessage: 'Search for issues, boards, projects, and filters',
		description:
			'Search field placeholder when the Jira tab is active and the user has a JSW license but no access to advanced roadmaps',
	},
	jira_advanced_search_issuesIssueTermRefresh: {
		id: 'global_search.jira.advanced_search_issues-issue-term-refresh',
		defaultMessage: 'Work items',
		description:
			'Link label in the Jira advanced search footer (issue term refresh variant) that navigates to a full work items search page.',
	},
	jira_issues_section_headingIssueTermRefresh: {
		id: 'product_search_dialog.jira.issues_section_heading-issue-term-refresh',
		defaultMessage: 'Work items',
		description: 'Section heading for Jira work items results (issue term refresh variant).',
	},
	jira_view_all_issues_newIssueTermRefresh: {
		id: 'product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh',
		defaultMessage: 'View all work items',
		description:
			'Text for link that takes users to advanced search for issues - renamed from "Advanced issue search"',
	},
	jira_recently_viewed_issues_section_headingIssueTermRefresh: {
		id: 'product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh',
		defaultMessage: 'Recently viewed work items',
		description:
			'Section heading listing recently viewed Jira work items (issue term refresh variant).',
	},
	jira_search_placeholder_experiment_jsw_enabledIssueTermRefresh: {
		id: 'global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh',
		defaultMessage: 'Search for work items, boards, projects, and filters',
		description:
			'Search field placeholder when the Jira tab is active and the user has a JSW license but no access to advanced roadmaps',
	},
});
